/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/backfill_estimates" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates } from "./constants";
import type { AlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimatesResult } from "./types";
import { isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimatesResult } from "./validators";

export const getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates = reactQueryFetcherAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates,
  (
    signal: AbortSignal,
    appGroupId: string,
    bridgeId: string
  ): Promise<AlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimatesResult> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}/backfill_estimates`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimatesResult
);
